exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".datatable_sort_wrapper[data-v-9f244440] {\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-pack: justify;\n          justify-content: space-between;\n  cursor: pointer;\n}\n.datatable_sort_wrapper .slot[data-v-9f244440] {\n  white-space: nowrap;\n}\n.datatable_sort_wrapper .sort_icon[data-v-9f244440] {\n  color: #adb5bd;\n  margin-left: 0.5rem;\n}\n.datatable_sort_wrapper .sort_icon.active[data-v-9f244440] {\n  color: #000;\n}", ""]);

// exports
